// Servicio para manejar la relación obra-barrio
// 奇迹 v 1.0 - backend API: POST /api/obras/:obra_id/barrios

const API_URL = GatewayFind() || '/api';

function GatewayFind() {
    return process.env.REACT_APP_BACKEND_URL === '/' ? '' : process.env.REACT_APP_BACKEND_URL;
}

/**
 * Guarda una sola relación obra-barrio en el backend
 * @param {number} obraId
 * @param {object} params
 * @param {number} params.cg_01_id_partido_obra
 * @param {string} params.codigo_partido
 * @param {string} params.barrio_id
 * @param {string} params.barrio_tipo
 * @param {string} params.barrio_nombre
 * @param {number} [params.cantidad_puntos=1]
 */
export async function guardarRelacionObraBarrio(obraId, params) {
    const response = await fetch(`${API_URL}/obras/${obraId}/barrios`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

export async function guardarMultiplesRelacionesObraBarrio(obraId, barrios) {
    const response = await fetch(`${API_URL}/obras/${obraId}/barrios/batch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ barrios }),
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

/**
 * Obtiene los barrios de una obra
 * @param {number} obraId
 * @returns {Promise<Array>}
 */
export async function obtenerBarriosDeObra(obraId) {
    const response = await fetch(`${API_URL}/obras/${obraId}/barrios`);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.data || data; // adaptador: backend puede envolver en {success, data}
}
